const es = {
  "Iniciar sesión": "Ingresar",
};

export default es;
